import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Nav from '../../components/tvNav';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SubNav from '../../components/SubNav';
import ToTop from '@ifeng-fe/container_channel/common/client/components/toTop';

const Intro = errorBoundary(props => {
    return <div dangerouslySetInnerHTML={{ __html: props.content }} />;
});

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { leftNav, intro },
        } = this.props;

        const { content } = this.props;
        // 头部
        const headerData = {
            nav: { ...content.nav, limit: 17 },
            topAd: content.topAd,
            search: content.search,
            logo: content.logo,
        };
        const footerData = {
            footerNav: content.footerNav,
            footerCopyright: content.footerCopyright,
        };

        return (
            <div className={styles.phtv_container}>
                <div className={styles.headerWrap}>
                    <Header content={headerData} />
                </div>
                <Chip id="230203" type="struct" title="凤凰卫视-首页子导航" groupName="正文" content={content.subNav}>
                    <SubNav theme={styles.subNav} active={content.paramName} />
                </Chip>
                <div className={styles.phtv_body}>
                    <Chip id="170113" type="struct" title="导航" groupName="nav" content={leftNav}>
                        <Nav type={0} />
                    </Chip>
                    <div className={styles.content}>
                        <div className={styles.title_img} />
                        <div className={styles.small_title} />
                        <Chip id="130268" type="static" title="公司介绍" groupName="content" content={intro}>
                            <Intro />
                        </Chip>
                    </div>
                </div>
                <div className={styles.footerWrap}>
                    <Footer content={footerData} />
                </div>
                <ToTop windowMode="normal" />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default errorBoundary(Layout);
